import { BiometricAuth, BiometryError } from "@aparajita/capacitor-biometric-auth";
import { isNative } from "./platform";

const BIOMETRIC_ENABLED_KEY = "workitect.biometric.enabled";

/** Whether the user opted-in to biometric re-auth. */
export function isBiometricEnabled(): boolean {
  return localStorage.getItem(BIOMETRIC_ENABLED_KEY) === "1";
}

export function setBiometricEnabled(enabled: boolean): void {
  if (enabled) localStorage.setItem(BIOMETRIC_ENABLED_KEY, "1");
  else localStorage.removeItem(BIOMETRIC_ENABLED_KEY);
}

/**
 * Prompts Face ID / Touch ID / fingerprint. Resolves `true` on success.
 * On web or if biometrics unavailable, resolves `true` (no-op gate).
 */
export async function promptBiometricUnlock(): Promise<boolean> {
  if (!isNative() || !isBiometricEnabled()) return true;

  try {
    const info = await BiometricAuth.checkBiometry();
    if (!info.isAvailable) return true;
    await BiometricAuth.authenticate({
      reason: "Unlock The Workitect",
      cancelTitle: "Cancel",
      allowDeviceCredential: true,
      iosFallbackTitle: "Use passcode",
      androidTitle: "Unlock The Workitect",
      androidSubtitle: "Confirm it's you",
    });
    return true;
  } catch (err) {
    if (err instanceof BiometryError) {
      console.warn("[biometric]", err.code, err.message);
    }
    return false;
  }
}
